<template>
  <div>
    <div class="form-container ou-donation-form" id="elm">
      <div class="holder ncsyupseell">
        <PaymentForm class="form-horizontal" @submit.prevent="doUpsell">
          <FormSection title="1. My Donation">
            <div class="frequency">
              <PaymentOptions addMonthly monthesSelector/>
            </div>
            <NcsyWestcoastUpsell @close="submit" v-if="showUpsell" />
            <NcsyWestcoastAmounts />
            <ErrorLabel field="amount" style="text-align: right" />
          </FormSection>
          <FormSection title="2. Donation Designation">
            <NcsyWestcoastDesignation />
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="3. Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="4. Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="5. Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" @click.prevent="doUpsell" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { usePaymentForm } from "~/shared/use-payment-form";
import { ref } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const { setValue, form, getValue, submit } = usePaymentForm();

    const showUpsell = ref(false);

    return {
      form,
      getValue,
      setValue,
      showUpsell,
      submit,
      doUpsell() {
        showUpsell.value =
          !!form.value.amount &&
          parseInt(form.value.amount) == 500 &&
          !form.value.dayOfMonth;

        if (!showUpsell.value) {
          submit();
        }
      },
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}::v-deep .monthly-note {
    font-size: 13px;
    line-height: 1.4;
    margin-top: 22px;
    display: flex;
    align-items: center;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;

  input[type=radio]{
    display: none;
  }
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}

::v-deep select {
    border-radius: 4px;
    border: 1px solid #ddd;
    background-color: #f7f9fb;
    color: #222;
    cursor: pointer;
    width: 100%;
    outline: 0;
    box-sizing: border-box;
    min-width: 80px;
    transition: border-color .3s ease-in-out;
    font-size: 16px;
    align-items: center;
    box-shadow: none;
    display: inline-flex;
    height: 44px;
    justify-content: flex-start;
    padding: 0 10px;
    position: relative;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6IzQ0NH08L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xLjQxIDQuNjdsMS4wNy0xLjQ5IDEuMDYgMS40OUgxLjQxek0zLjU0IDUuMzNMMi40OCA2LjgyIDEuNDEgNS4zM2gyLjEzeiIvPjwvc3ZnPg==);
    background-repeat: no-repeat;
    background-position: 95% 50%;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container .amount_other__wrapper:before {
    padding: 0px 8px 0px;
}
::v-deep #amount_other {
width: 100%;
    max-width: 100% !important;
    margin-left: 84px;
    height: 42px;
    padding-left: 7px;
}
::v-deep .styled-radio-container .amount_other__wrapper:after {
  content: none !important;
}


::v-deep .styled-radio-container .amount_other__wrapper.amount-row {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
}

.ncsyupseell {
  position: relative;
}


</style>
